export default __webpack_public_path__ + "static/media/acerola.d284308c.jpg";